<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import { useApiStore } from '@/modules/apiStore/stores/apiStore'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import { ERouteNames } from '@/router/ERouteNames'

import tree1 from '@images/svg/tree1.svg?url'
import tree3 from '@images/svg/tree3.svg?url'

import authV2MaskDark from '@images/pages/mask-v2-dark.png'
import authV2MaskLight from '@images/pages/mask-v2-light.png'

const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

const apiStore = useApiStore()
const feedbackStore = useFeedbackStore()

const router = useRouter()
const { mdAndUp, smAndDown } = useDisplay()

const checkBackendStatus = async (silent = false) => {
  const backendAlive = await apiStore.checkBackendStatus()
  if (backendAlive) {
    await router.push({ name: ERouteNames.MONITORING })
  } else if (!silent) feedbackStore.showToast({ type: 'info', message: 'В данный момент работы еще не завершены, попробуйте позднее', time: 7000 })
}

// При заходе/перезагрузке страницы тех. работ молча пингуем бэк:
// если он уже поднялся — сразу уводим на рабочий экран без тоста.
onMounted(() => {
  checkBackendStatus(true)
})
</script>

<template>
  <div class="layout-blank">
    <VRow
      align="center"
      :class="{ 'px-3': smAndDown }"
      class="auth-wrapper min-h-100dvh"
      justify="center"
      no-gutters
    >
      <VCol
        class="d-flex align-center justify-center"
        cols="12"
        md="6"
        lg="4"
      >
        <div class="d-flex flex-column align-center ga-4">
          <img
            src="/img/iadaorepair.png"
            alt="Ведутся технические работы"
            class="service-works__img"
          >
          <div class="d-flex flex-column align-center ga-2">
            <div class="text-h1 title">
              Ведутся технические работы
            </div>
            <div class="text-h4 subtitle">
              Нажмите на кнопку "Обновить" для проверки завершения работ
            </div>
          </div>
          <VBtn
            prepend-icon="ri-refresh-line"
            @click="checkBackendStatus"
          >
            Обновить
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <!-- Декорации - только для десктопа -->
    <div
      v-if="mdAndUp"
      aria-hidden="true"
      class="auth-decorations"
    >
      <img
        :src="authThemeMask"
        alt="footer mask"
        class="auth-footer-mask"
      >
      <VImg :src="tree1" alt="tree image" class="auth-footer-tree" />
      <VImg :src="tree3" alt="tree image" class="auth-footer-tree-1" />
      <VImg :src="tree3" alt="tree image" class="auth-footer-tree-2" />
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth";

.title {
  color: rgb(var(--v-theme-primary-500)) !important;
}

.subtitle {
  color: rgba(var(--v-theme-text-secondary), var(--v-medium-emphasis-opacity)) !important;
}

.service-works__img {
  block-size: auto;
  max-block-size: 220px;
  max-inline-size: min(280px, 70vw);
  object-fit: contain;
}
</style>
